/*
 *   File : fund-select.js
 *   Author : https://evoqins.com
 *   Description : fund select component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React, { useState, useEffect } from "react";
import Select from "react-select";
import "../../Style/Components/select.scss";

const CustomFundOption = (props) => {
  const { innerProps, data } = props;

  return (
    <div
      {...innerProps}
      className="d-flex align-items-center justify-content-between px-3 py-2"
      style={{ cursor: "pointer", gap: 12 }}
    >
      <div className="d-flex align-items-center border-bottom border-white" style={{ gap: 12 }}>
        <img
          src={
            data.image ? data.image : require("../../Assets/Images/bank.png")
          }
          alt={data.label}
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            objectFit: "cover",
          }}
        />

        <span style={{ fontSize: 14, fontWeight: 500 }}>{data.label}</span>
      </div>

      <div style={{ fontSize: 14, fontWeight: 500 }}>{data.module}</div>
    </div>
  );
};

const portalTarget = typeof document !== "undefined" ? document.body : null;

export default function FundSelect({
  options = [],
  value,
  onChange,
  placeholder = "Select Fund",
}) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    if (options.length > 0) {
      setMenuIsOpen(true);
    } else {
      setMenuIsOpen(false);
    }
  }, [options]);

  const components = {
    DropdownIndicator: null,
    IndicatorSeparator: null,
    Option: CustomFundOption,
  };

  /* Control must keep a real layout box (no display:none). Menu is portaled to body with
     menuPosition=fixed so page footers (e.g. Add basket Submit) do not stack above the list. */
  const hiddenControl = (base) => ({
    ...base,
    minHeight: 2,
    height: 2,
    margin: 0,
    padding: 0,
    opacity: 0,
    border: "none",
    boxShadow: "none",
    pointerEvents: "none",
    cursor: "default",
    overflow: "hidden",
  });

  return (
    <div className="position-relative w-100">
      <Select
        options={options}
        value={value}
        onChange={(v) => {
          onChange(v);
          setMenuIsOpen(false);
        }}
        placeholder={placeholder}
        className="custom-filter-single-select e-fund-select"
        classNamePrefix="custom-filter"
        isSearchable={false}
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        menuPlacement="auto"
        menuPosition="fixed"
        menuPortalTarget={portalTarget}
        maxMenuHeight={220}
        closeMenuOnScroll={false}
        components={components}
        styles={{
          container: (base) => ({ ...base, minHeight: 0 }),
          control: hiddenControl,
          valueContainer: (base) => ({
            ...base,
            padding: 0,
            height: 0,
            minHeight: 0,
            overflow: "hidden",
          }),
          indicatorsContainer: () => ({ display: "none" }),
          singleValue: (base) => ({ ...base, margin: 0, opacity: 0 }),
          placeholder: (base) => ({ ...base, margin: 0, opacity: 0 }),
          menuPortal: (base) => ({ ...base, zIndex: 100000 }),
          /* Minimal gap under the search field (anchor is Input.afterControl). */
          menu: (base, state) => ({
            ...base,
            marginTop: state?.placement === "top" ? 0 : -20,
            marginBottom: state?.placement === "top" ? -20 : 0,
            borderRadius: 20,
            maxHeight: 220,
            overflow: "hidden",
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: 220,
            overflowY: "auto",
          }),
        }}
      />
    </div>
  );
}
